module.exports = __webpack_public_path__ + "img/delete_purple.4d3dd2c9.svg";